// extracted by mini-css-extract-plugin
export var bottomHolder = "courses-list-item-module--bottom-holder--cfe81";
export var buttonHolder = "courses-list-item-module--button-holder--a4e14";
export var content = "courses-list-item-module--content--41ef3";
export var iconInfoWrapper = "courses-list-item-module--icon-info-wrapper--a73b5";
export var iconLock = "courses-list-item-module--icon-lock--5cdba";
export var image = "courses-list-item-module--image--178dc";
export var imageWrapper = "courses-list-item-module--image-wrapper--1c315";
export var listContentWrapper = "courses-list-item-module--list-content-wrapper--f125d";
export var listItem = "courses-list-item-module--list-item--9f17d";
export var lockIconWrapper = "courses-list-item-module--lock-icon-wrapper--a5a83";
export var placeHolder = "courses-list-item-module--place-holder--94152";
export var placeHolderContent = "courses-list-item-module--place-holder-content--bc57c";
export var ratioClass = "courses-list-item-module--ratio-class--a08ab";
export var timeIcon = "courses-list-item-module--time-icon--1b424";
export var timeIconWrapper = "courses-list-item-module--time-icon-wrapper--a8441";
export var tvIcon = "courses-list-item-module--tv-icon--62429";
export var tvIconWrapper = "courses-list-item-module--tv-icon-wrapper--67050";
export var wrapper = "courses-list-item-module--wrapper--8736a";